import { connect } from 'react-redux';

import { deleteById, Entities, fetchAll, fetchAllCustomRepository, getEntities, search } from 'src/common/index';
import AdminBusRequestsOverviewAdministration from 'src/components/admin/bus-requests-overview/admin-bus-requests-overview-administration';

const mapStateToProps = state => {
    return {
        busRequests: getEntities(state, Entities.BUS_REQUESTS),
    };
};

const AdminBusRequestsOverviewAdministrationContainer = connect(mapStateToProps, {
    fetchAll,
    fetchAllCustomRepository,
    deleteById,
    search,
})(AdminBusRequestsOverviewAdministration);

export default AdminBusRequestsOverviewAdministrationContainer;
